import type Quill from 'quill/core';

const SPEED = 6;
const SENSITIVITY = 80;

class DraggingAutoScroll {
  private mouseTopOffset: number | null = null;
  private scrollAnimationFrame: number | null = null;
  private hasStarted = false;

  constructor(private quill: Quill) {}

  start() {
    if (this.hasStarted) return;
    this.hasStarted = true;

    this.mouseTopOffset = null;
    this.scrollAnimationFrame = requestAnimationFrame(
      this.handleAnimationFrame,
    );
  }

  setMouseYOffset(value: number) {
    this.mouseTopOffset = value;
  }

  stop() {
    if (!this.hasStarted) return;
    this.hasStarted = false;

    if (this.scrollAnimationFrame) {
      cancelAnimationFrame(this.scrollAnimationFrame);
      this.scrollAnimationFrame = null;
    }

    this.mouseTopOffset = null;
  }

  private handleAnimationFrame = () => {
    this.performScrollIfNeeded();

    this.scrollAnimationFrame = requestAnimationFrame(
      this.handleAnimationFrame,
    );
  };

  private performScrollIfNeeded = () => {
    if (typeof this.mouseTopOffset !== 'number') return;

    const { scrollingContainer } = this.quill;

    const { top, bottom } =
      scrollingContainer === document.scrollingElement
        ? { top: 0, bottom: window.innerHeight }
        : scrollingContainer.getBoundingClientRect();

    if (this.mouseTopOffset < top + SENSITIVITY) {
      scrollingContainer.scrollTop -= SPEED;
    } else if (this.mouseTopOffset > bottom - SENSITIVITY) {
      scrollingContainer.scrollTop += SPEED;
    }
  };
}

export default DraggingAutoScroll;
